import { UnauthorizedComponent } from './components/unauthorized/unauthorized.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@irembo-andela/irembogov3-common';
import { RoleGuard } from './core/guards/role.guard';

const routes: Routes = [
  {
    path: 'dashboard',
    canActivate: [AuthGuard, RoleGuard],
    children: [
      { path: 'unauthorized', component: UnauthorizedComponent },
      {
        path: 'reporting',
        loadChildren: () =>
          import('./modules/reports/reports.module').then(m => m.ReportsModule),
      },
      {
        path: 'users',
        loadChildren: () =>
          import('./modules/users/users.module').then(m => m.UsersModule),
      },
      {
        path: 'services',
        loadChildren: () =>
          import('./modules/services/services.module').then(
            m => m.ServicesModule
          ),
      },
      { path: '**', redirectTo: 'reporting' },
    ],
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth/auth.module').then(m => m.AuthModule),
  },
  { path: '**', redirectTo: 'dashboard' },
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
